import { z } from "zod"

export const aircraftManualStatusSchema = z
    .enum(["good_to_fly", "needs_maintenance", "grounded"])
    .nullable()
export type AircraftManualStatus = z.infer<typeof aircraftManualStatusSchema>

export const aircraftRecordSchema = z.object({
    id: z.uuid(),
    org_id: z.uuid(),
    nickname: z.string().nullable(),
    manufacturer: z.string(),
    model: z.string().nullable(),
    serial_number: z.string(),
    registration_number: z.string().nullable(),
    purchased_at: z.string().nullable(),
    warranty_expires_at: z.string().nullable(),
    notes: z.string().nullable(),
    manual_status: aircraftManualStatusSchema,
    status_updated_at: z.string().nullable(),
    status_updated_by: z.guid().nullable(),
})

export const aircraftSchema = aircraftRecordSchema.transform((r) => ({
    id: r.id,
    orgId: r.org_id,
    nickname: r.nickname,
    manufacturer: r.manufacturer,
    model: r.model,
    serialNumber: r.serial_number,
    registrationNumber: r.registration_number,
    purchasedAt: r.purchased_at,
    warrantyExpiresAt: r.warranty_expires_at,
    notes: r.notes,
    manualStatus: r.manual_status,
    statusUpdatedAt: r.status_updated_at,
    statusUpdatedBy: r.status_updated_by,
}))

export const creatableAircraftSchema = aircraftRecordSchema.omit({
    id: true,
    org_id: true,
    status_updated_at: true,
    status_updated_by: true,
})

export const updatableAircraftSchema = aircraftRecordSchema
    .omit({ id: true, org_id: true, status_updated_at: true, status_updated_by: true })
    .partial()

export const updateAircraftStatusBodySchema = z.object({
    status: aircraftManualStatusSchema,
    reset_template_ids: z.array(z.string()).default([]),
})

export type UpdateAircraftStatusBody = z.infer<typeof updateAircraftStatusBodySchema>

export type AircraftRecord = z.infer<typeof aircraftRecordSchema>
export type Aircraft = z.infer<typeof aircraftSchema>
export type CreatableAircraft = z.infer<typeof creatableAircraftSchema>
export type UpdatableAircraft = z.infer<typeof updatableAircraftSchema>
